import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getSubjects } from "../../redux/actions/subjectActions";
import AppSelectFilter from "./AppSelectFilter";

interface Props {
  value: string;
  onChange: (subjectId: string) => void;
  label?: string;
  allLabel?: string;
  minWidth?: number | string;
}

export const SubjectSelectFilter: React.FC<Props> = ({
  value,
  onChange,
  label = "Subject",
  allLabel = "All Subjects",
  minWidth = 140,
}) => {
  const dispatch = useAppDispatch();
  const {
    items: subjects,
    loadingFetchAll: loading,
    errorFetchAll: error,
  } = useAppSelector((state) => state.subject);
  const attempted = useRef(false);

  useEffect(() => {
    if (!subjects.length && !loading && !error && !attempted.current) {
      attempted.current = true;
      dispatch(getSubjects());
    }
  }, [dispatch, subjects.length, loading, error]);

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={subjects.map((s) => ({
        value: s.id,
        label: s.name ?? "Unnamed Subject",
      }))}
      allLabel={allLabel}
      minWidth={minWidth}
    />
  );
};

export default SubjectSelectFilter;
